import React from 'react';
import { Query } from 'react-apollo';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getAircraftType } from '../../graphql/queries/aircraftType';
import Header from '../common/Header';
import RenderImage from '../common/RenderImage';
import Pictures from '../unsplashImageSearch/Pictures';

const AircraftType = () => {
  let { id } = useParams();
  const { t } = useTranslation();

  return (
    <div className="list">
      <Header
        title="aircraftTypes.show.title"
        linkTo={`/admin/aircraft_types/${id}/edit`}
        buttonLabel="shared.edit"
      />
      <Query {...getAircraftType(id)}>
        {({ loading, data }) => {
          if (loading) return <div className="lds-dual-ring" />;
          if (data) {
            const { aircraftType } = data;

            return (
              <div className="common-show">
                <div className="grid">
                  <div className="col-12">
                    <div className="common-show__infos">
                      <div className="col-12">
                        <div className="common-show__infos--field">
                          {t('aircraftTypes.attributes.name')}
                        </div>
                        <div className="common-show__infos--value">{aircraftType.name}</div>
                        <div className="common-show__infos--field">
                          {t('aircraftTypes.attributes.code')}
                        </div>
                        <div className="common-show__infos--value">{aircraftType.code}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="common-show__images">
                  <div className="common-show__infos--field">
                    {t('aircraftTypes.attributes.image')}
                  </div>
                  <RenderImage url={aircraftType.imageUrls.large} />
                  <div className="common-show__infos--field">
                    {t('unsplashImageSearch.labels.unsplashImage')}
                  </div>
                  <Pictures imageableType={'AircraftType'} imageableId={id} />
                </div>
              </div>
            );
          }
          return null;
        }}
      </Query>
    </div>
  );
};

export default AircraftType;
